import React from 'react'

import Text, { TextProps } from './Text'

const Header: React.FC<TextProps> = ({ ...rest }) => <Text as="h1" {...rest} />

export default Header
